import React, { FC } from "react"
import { Redirect, Route } from "react-router-dom"
import { SendMessage } from "./send-message/SendMessage"
import { TalkToCarrotLocations } from "../../pages/talk-to-carrot/talk-to-carrot"
import { createErrorBoundary } from "../../utils/createErrorBoundary"
import { ErrorPage } from "../views/app/ErrorPage"
import { Switch } from "services/routing/Switch"

const TalkToCarrotRouter: FC = () => {
  const TTCErrorBoundary = createErrorBoundary(ErrorPage)
  return (
    <TTCErrorBoundary>
      <Switch>
        <Route path="/talk-to-carrot/sendmessage/:topic" exact component={SendMessage} />
        <Redirect
          exact
          path="/talk-to-carrot/sendmessage/bookappointment/provider/:providerName"
          to="/providerfinder/requestappointment/:providerName"
        />
        <Route path="/talk-to-carrot" component={TalkToCarrotLocations} />

        <Redirect from="/ava-bracelet" to="/talk-to-carrot/sendmessage/ava-bracelet" />

        {/*Must stay at the bottom as the catchall*/}
        <Redirect from="/chat" to="/talk-to-carrot" />
      </Switch>
    </TTCErrorBoundary>
  )
}

export { TalkToCarrotRouter }
